// @flow
import React from 'react';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder.jsx';
import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import ratiosUtils from 'Components/utils/ratios/ratios.utils.js';
import { truncate } from 'Components/utils/string/string.util';
import { t } from 'Src/i18n';

type Props = {
  mediaUrl: string,
  text: string,
  title: string,
};

export function ProductExclusiveCollectionSpace(props: Props) {
  const { mediaUrl, text, title } = props;

  return (
    <article className="flex">
      <div className="text-center md:text-initial md:w-1/2 md:rtl:pr-8 pt-5 md:pt-16">
        <div style={{ width: '10rem' }} className="m-auto md:m-0">
          <ImagePlaceholder aspectRatio={100 * ratiosUtils.values[ratiosUtils.XL]}>
            <div className="flex items-center justify-center h-full text-blue">
              <Icon
                className="mb-5"
                color={COLORS.DEEP_BLUE}
                isNotSquare
                name={ICONS.CLUBMED_EXCLUSIVE}
                width="10rem"
              />
            </div>
          </ImagePlaceholder>
        </div>
        <Title theme="title-serif-1" className="md:max-w-4/5 pt-4">
          {truncate(title, 60)}
        </Title>
        <TextSeeMore
          className="mt-5 max-w-9/10"
          hasNoScrollOnCollapse
          isCollapseEnabled
          seeLessLabel={t('common.loadLess')}
          seeMoreLabel={t('common.viewMore')}
          seeMoreSize={110}
          text={text}
          theme="text-sans-3"
        />
      </div>
      <div className="hidden md:block h-full image-responsive-cell inset-border-after mb-15 sm:mb-0 w-1/2">
        <Image imageUrl={mediaUrl} ratioKey={ratiosUtils.R_13_BY_12} />
      </div>
    </article>
  );
}
